var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: { rules: _vm.validateRules },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c(
                  "div",
                  { staticClass: "w-100-per", attrs: { id: _vm.id } },
                  [
                    _c("transition", { attrs: { name: "idle-fade" } }, [
                      !_vm.loading && !_vm.success
                        ? _c(
                            "div",
                            {
                              class: [
                                "content",
                                "content-idle",
                                { "error-upload": errors.length }
                              ]
                            },
                            [
                              _c("span", { staticClass: "info" }, [
                                _vm._v(
                                  "Arraste e solte ou clique para selecionar um arquivo."
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "format" }, [
                                _vm._v(
                                  "Formato(s) suportado(s): " +
                                    _vm._s(_vm.fileTypes.join(", "))
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    !_vm.loading && errors.length
                      ? _c("span", [_vm._v(_vm._s(errors[0]))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "width" } },
                      [
                        _vm.loading
                          ? _c(
                              "el-row",
                              {
                                staticClass: "content content-loader",
                                style: {
                                  width:
                                    (_vm.percentage < 20
                                      ? 20
                                      : _vm.percentage
                                    ).toString() + "%"
                                }
                              },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.fileName))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "size" }, [
                                    _vm._v(_vm._s(_vm.fileSize) + " Kb")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "buttons-and-label-fade" } },
                                  [
                                    _vm.success
                                      ? _c(
                                          "el-col",
                                          {
                                            staticClass:
                                              "column right float-left",
                                            attrs: { span: 12 }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("Carregado com sucesso!")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("app-resumable", {
                  ref: _vm.id,
                  attrs: {
                    target: _vm.targetUrl,
                    fileType: _vm.fileTypes,
                    idDrop: _vm.id,
                    idInput: _vm.id,
                    fileTypeErrorCallback: _vm.fileTypeErrorCallback,
                    maxSize: _vm.maxSixe
                  },
                  on: {
                    onSuccess: _vm.onSuccessEvent,
                    onError: _vm.onErrorEvent,
                    onProgress: _vm.onProgressEvent,
                    fileAdded: _vm.onFileAddedEvent
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-548f1f04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548f1f04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/DocumentUpload/UploadResumable/UploadResumable.vue
// module id = null
// module chunks = 